import {
  POINT_SHADOW_BIAS,
  SHADOW_MAP_SIZE,
  SPOT_CAMERA_FAR,
  SPOT_CAMERA_FOCUS,
  SPOT_CAMERA_FOV,
  SPOT_CAMERA_NEAR,
} from '@constants'
import { useAppStore } from '@store'
import { LightProps } from '@types'
import { radians } from '@utils/generalMaths/geometry'
import { useMemo, useRef } from 'react'
import { SpotLight } from 'three'
import { LightPivot } from '../../ViewerManager/LightPivot'
import { LightMesh3D } from './LightMesh3D'

export function SpotLight3D({
  id,
  //x,
  y,
  z,
  textures,
  color,
  // intensity,
  catalogID,
  matrix,
}: LightProps) {
  const { castShadow, angle, penumbra, distance } = textures
  const power = (textures as any)?.power
  const light = useAppStore.use.items().get(id as any)
  const intensity = (light as any)?.intensity
  const items = useAppStore.use.items()
  
  // Verificar si hay paredes en la escena
  const hasWalls = Array.from(items.values()).some((item) => item.type === 'walls')
  
  // Reducir la intensidad cuando no hay paredes para evitar sobre-exposición
  let baseIntensity = intensity ? (intensity * 30) / 100 : 0
  if (!hasWalls && catalogID === 'Luzgeneral2') {
    baseIntensity = baseIntensity * 0.45 // Reducir a 45% cuando no hay paredes (un poco más de claridad)
  }
  const calcIntensity = baseIntensity
  
  const x = (light as any)?.width || 10
  
  // Validar que x no sea NaN o Infinity
  const validX = isNaN(x) || !isFinite(x) ? 10 : x
  const targetX = validX / 2
  const targetY = -10
  const targetZ = validX / 2
  
  // Validar que las posiciones del target no sean NaN
  const validTargetX = isNaN(targetX) || !isFinite(targetX) ? 5 : targetX
  const validTargetY = isNaN(targetY) || !isFinite(targetY) ? -10 : targetY
  const validTargetZ = isNaN(targetZ) || !isFinite(targetZ) ? 5 : targetZ
  
  const spotlight = useMemo(() => new SpotLight(), [])
  const ref = useRef()
  
  // const helper = useHelper(ref, SpotLightHelper)
  return (
    <LightPivot
      pivotKey={`${validX}-${z}-${id}`}
      id={id}
      matrix={matrix}
    >
      <primitive
        object={spotlight}
        name={id}
        ref={ref}
        position={[validX / 2, 0, validX / 2]}
        power={(power as any)?.value ?? 0.4}
        intensity={calcIntensity}
        castShadow={castShadow.value}
        color={color}
        decay={0}
        angle={radians(angle.value / 2)}
        penumbra={penumbra.value}
        distance={distance.value}
        shadow-mapSize={SHADOW_MAP_SIZE}
        shadow-camera-far={SPOT_CAMERA_FAR}
        shadow-camera-near={SPOT_CAMERA_NEAR}
        shadow-camera-fov={SPOT_CAMERA_FOV}
        shadow-camera-focus={SPOT_CAMERA_FOCUS}
        shadow-bias={POINT_SHADOW_BIAS}
      />
      <primitive
        object={spotlight.target}
        position={[validTargetX, validTargetY, validTargetZ]}
      />
      <LightMesh3D
        id={id}
        catalogID={catalogID}
      />
    </LightPivot>
  )
}
